import module from "../module";
import template from "./enum-picker.tmpl.html";

import { NC_PRIVILEGE as ncPrivilegeEnum } from "#/constants/index";

module.directive("ncPrivilegePicker" /* @ngInject */, function() {
  return {
    restrict: "A",
    require: "ngModel",
    replace: true,
    scope: {
      model: "=ngModel"
    },
    template,
    priority: 100,
    controller: /*@ngInject */ function($scope) {
      $scope.enums = ncPrivilegeEnum;
      $scope.model = $scope.model || null; //default
    }
  };
});
